import { Controller } from "@website/form/hook/form.hooks";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { TextField } from "@website/ui/text-field";
import { deepCompare } from "@website/utils/deep-compare";
import { useTelesales } from "@website/widget/telesales/telesales-form/hooks";
import {
  TelesalesFormPropertiesType,
  TelesalesFromDataType
} from "@website/widget/telesales/telesales-form/types";
import { memo } from "react";
import { Control } from "react-hook-form";

const Component = ({
  onClose,
  isSubmitBefore,
  requestData,
  storageKey,
  reasons,
  description,
  onSuccess,
  onSubmitSuccess
}: TelesalesFormPropertiesType) => {
  const { handleSetEvent, isPhoneStep, control, isPending, handleSubmit } =
    useTelesales({
      onClose,
      requestData,
      storageKey,
      reasons,
      onSuccess,
      onSubmitSuccess
    });

  if (isSubmitBefore) {
    return (
      <>
        <div className="text-body-2 text-on-surface-high-emphasis">
          درخواست شما قبلا ثبت شده است و به زودی کارشناسان ما با شما تماس خواهند
          گرفت.
        </div>
        <Button
          children="بستن"
          className="mt-4"
          color="secondary"
          fullWidth
          onClick={onClose}
          size="large"
          variant="outline"
        />
      </>
    );
  }

  return (
    <form onSubmit={handleSubmit(handleSetEvent)}>
      <div className="text-body-2 text-on-surface-high-emphasis">
        {isPhoneStep ? (
          <>
            <div>لطفا شماره موبایل خود را وارد کنید.</div>
            <div className="my-6">
              <Controller
                control={control as unknown as Control<TelesalesFromDataType>}
                name="freeTransferMobileNumber"
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    StartIcon={<MaterialIcon name="phone_iphone" />}
                    error={Boolean(error)}
                    fullWidth
                    helperText={error?.message}
                    inputMode="text"
                    placeholder="شماره موبایل"
                    type="tel"
                    {...field}
                  />
                )}
              />
            </div>
          </>
        ) : (
          <>
            <div className="mb-4">
              لطفا دلایل خود را برای رزرو تلفنی مشخص کنید.
            </div>
            <div className="flex w-full flex-wrap gap-x-2 gap-y-4">
              {Object.entries(reasons).map((reason) => (
                <div key={reason[0]}>
                  <Controller
                    control={
                      control as unknown as Control<TelesalesFromDataType>
                    }
                    name={reason[0]}
                    render={({ field }) => (
                      <>
                        <input
                          className="peer hidden"
                          id={reason[0]}
                          type="checkbox"
                          {...field}
                        />
                        <label
                          className="text-button text-on-surface-high-emphasis border-on-surface-disable peer-checked:text-secondary peer-checked:border-secondary inline-flex cursor-pointer overflow-hidden rounded-full border px-3 py-2"
                          htmlFor={reason[0]}
                        >
                          {reason[1]}
                        </label>
                      </>
                    )}
                  />
                </div>
              ))}
            </div>
            <div className="my-6">
              <Controller
                control={control as unknown as Control<TelesalesFromDataType>}
                name="reason"
                render={({ field }) => (
                  <textarea
                    className="border-on-surface-disable w-full rounded-lg border p-4"
                    placeholder="سایر دلایل خود را اینجا بنویسید."
                    rows={4}
                    {...field}
                  />
                )}
              />
            </div>
          </>
        )}
        <div>{description}</div>
      </div>
      <Button
        children={isPhoneStep ? "تایید و ادامه" : "ثبت درخواست"}
        className="mt-4"
        color="secondary"
        fullWidth
        loading={isPending}
        size="large"
        type="submit"
        variant="contained"
      />
    </form>
  );
};
export const TelesalesForm = memo(Component, deepCompare);
